import { Controller } from '@hotwired/stimulus';

/**
 * Sticky Nav Controller
 *
 * Adds a class once the page has scrolled past a threshold, so a sticky header
 * can go from translucent to solid. Decorative only — the header is fully
 * usable without it.
 *
 * Usage:
 *   <header data-controller="sticky-nav"
 *           data-sticky-nav-offset-value="20"
 *           data-sticky-nav-solid-class="is-solid">
 */
export default class extends Controller {
  static values = {
    offset: { type: Number, default: 20 },
  };

  static classes = ['solid'];

  declare offsetValue: number;
  declare solidClass: string;
  declare hasSolidClass: boolean;

  private onScroll = () => {
    const cls = this.hasSolidClass ? this.solidClass : 'is-solid';
    this.element.classList.toggle(cls, window.scrollY > this.offsetValue);
  };

  connect() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll);
  }
}
